fourToldApp.factory("templates", function($templateCache){
    $templateCache.remove('signature.html');
    $templateCache.remove('loanList.html');
    $templateCache.remove('address.html');
    $templateCache.remove('security_questions.html');
    return {
        'template': function() {
          $templateCache.put('loanList.html',          
          '<div class="scroll-list-basic" >'+
             '<div class="container" >'+
                '<div class="row" layout-align="center center">'+
                    '<div class="col-xs-12 col-sm-8 col-md-5 col-xs-offset-0 col-sm-offset-2 col-md-offset-4">'+
                        '  <md-dialog style="max-width: 100%">'+
                            '<div ng-if="progressCircular" align="center" class="loading">'+
                                '  <md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
                            '</div>'+
                            '<form ng-cloak>'+
                                '<md-toolbar style="color: #1E89D1; background-color: white; padding: 20px 0px 0px 0px;">'+
                                    '<div layout="row" layout-align="center center"><img style="width: 50px; height: 50px;" ng-src="../images/iconsChat/solicitudloan.png" /></div>'+
                                    '<div layout="row" layout-align="center center" style="margin:10px">'+
                                        '{{ metadata.windowTitle }}'+
                                    '</div>'+
                                '</md-toolbar>'+
                                '<md-dialog-content class="dialog-loan">'+
                                    '<div class="md-dialog-content content-dialog-loan">'+
                                        '<div style="overflow-y: auto;">'+
                                            '<md-list ng-repeat="item in metadata.lenderList">'+
                                                '<md-list-item  ng-repeat="program in item.programs track by $index" >'+
                                                    '<md-divider ng-if="!$last"></md-divider>'+
                                                    '<div class="md-3-line" layout="column" style="margin-bottom:20px; margin-top:10px;"  >'+
                                                        '<div layout="row">'+
                                                            '<img ng-if="program.programDetailInfo.logo!=\'\' &&  !program.programDetailInfo.logo.startsWith(\'http\')" ng-src="{{iconEsb}}{{program.programDetailInfo.logo}}" alt="logo" style="border-radius: 0px;"  width="25%" class="md-avatar" layout-align="{{message.layout}}" />'+
                                                            '<img ng-if="program.programDetailInfo.logo!=\'\' && program.programDetailInfo.logo.startsWith(\'http\')" ng-src="{{program.programDetailInfo.logo}}" alt="logo" style="border-radius: 0px;"  width="25%" class="md-avatar" layout-align="{{message.layout}}" />'+
                                                            '<div class="md-list-item-text" layout="column">'+
                                                                '<p> <b>{{ program.name }}</b></p>'+
                                                                ' <div ng-if="program.type != \'REVOLVING_CREDIT\'" ng-repeat="field in program.programDetailInfo.description.fields track by $index" layout="row" >'+
                                                                    '<img ng-if="field.icon!=\'\' && !field.icon.startsWith(\'http\')" style=" margin-right: 15px;"  ng-src="{{iconEsb}}{{field.icon}}" alt="logo" style="border-radius: 0px;"   width="20px"; height="18px"  />'+
                                                                    '<img ng-if="field.icon!=\'\' && field.icon.startsWith(\'http\')" style=" margin-right: 15px;"  ng-src="{{field.icon}}" alt="logo" style="border-radius: 0px;"   width="20px"; height="18px"  />'+
                                                                    '<p>{{ field.name }}:<b>{{ field.value }}</b> </p>'+
                                                                '</div>'+                                                        
                                                                '<p ng-if="program.type == \'REVOLVING_CREDIT\' && program.revolvingCreditActivated == false" style="color:#07816a;">Solicitar</p>'+
                                                                '<p ng-if="program.type == \'REVOLVING_CREDIT\' && program.revolvingCreditActivated == true" style="color:#07816a;">Disponible: {{ program.revolvingCreditAccountBalance | currency:"":0}}</p>'+
                                                                '<p ng-if="program.type == \'REVOLVING_CREDIT\' && program.revolvingCreditActivated == true" style="color:#07816a;">Usar cupo</p>'+
                                                                
                                                            '</div>'+
                                                            '<img alt="logo" id="select_icon{{$index}}" ng-click="selectOption(program.id, program, $index, item)" style="float : right;" width="10%" data-ng-src="images/iconsChat/grayyes.png" class="md-avatar" layout-align="{{message.layout}}" />'+
                                                        '</div>'+
                                                        ' <div ng-if="program.type != \'REVOLVING_CREDIT\'" ng-repeat="field in program.programDetailInfo.detail.fields track by $index" layout="row"   >'+
                                                                '<img ng-if="field.icon!=\'\' && !field.icon.startsWith(\'http\')" style=" margin-right: 15px;"  ng-src="{{iconEsb}}{{field.icon}}" alt="logo" style="border-radius: 0px;"   width="20px"; height="18px"  />'+
                                                                '<img ng-if="field.icon!=\'\' && field.icon.startsWith(\'http\')" style=" margin-right: 15px;"  ng-src="{{field.icon}}" alt="logo" style="border-radius: 0px;"   width="20px"; height="18px"  />'+
                                                                '<p>{{ field.name }}:<b>{{ field.value }}</b> </p>'+
                                                        '</div>'+
                                                        '<mat-divider></mat-divider>'+
                                                        '<div layout="row" ng-if="program.programDetailInfo" >'+
                                                            '<div flex="" style="font-size: 15px;"><strong>Detalles</strong></div>'+
                                                            '<div flex="" layout="row" layout-align="end center">'+
                                                                '<span ng-class=\'showItemDetails[$index] || program.programDetailInfo.detail.expand  ? "fa fa-chevron-up" : "fa fa-chevron-down"\' style="font-size: 15px; color: #737373; margin-left: 50%; margin-right: 26px;" ng-click="toggleDetail($index, program); toggle = !toggle"></span>'+                                                                                                        
                                                            '</div>'+
                                                        '</div>'+
                                                        '<div ng-if="showItemDetails[$index] || program.programDetailInfo.detail.expand" layout="row" layout-align="start" id="layoutDetail{{$index}}">'+
                                                                '{{program.programDetailInfo.detail.body}}'+
                                                        '</div>'+
                                                    '</div>'+
                                                '</md-list-item>'+
                                            '</md-list>'+
                                        '</div>'+
                                    '</div>'+
                                '</md-dialog-content>'+
                                '<md-dialog-actions style="background-color: #F1F1F1; color: white; padding:0px;">'+
                                    '<div flex layout="row">'+
                                        '<div flex layout="row" layout-align="center center">'+
                                            '<md-button ng-disabled="!loan.lenderId" class="md-primary" style="color: #07816a" ng-click="selectedProgram()">'+
                                                'Enviar'+
                                            '</md-button>'+
                                        '</div>'+
                                        '<div flex layout="row" layout-align="center center">'+
                                            '<md-button ng-click="closeDialog()" class="md-warn">'+
                                                '  Cancelar'+
                                            '</md-button>'+
                                        '</div>'+
                                    '  </div>'+
                                '</md-dialog-actions>'+
                            '</form>'+
                        '</md-dialog>'+
                    '</div>'+
                '  </div>'+        
                '</div>'+            
          '</div>'
          );

          $templateCache.put('address.html',
          '<div class="container">'+
              '<div class="row">'+
                  '<div class="col-xs-12 col-sm-8 col-md-4 col-xs-offset-0 col-sm-offset-2 col-md-offset-5">'+
                      '<md-dialog style="max-width: 100%">'+
                          '<md-toolbar class="md-hue-3" style="color: white; background-color: #1E89D1;" ng-syle="theme.button_selection_chat">'+
                              '<div class="md-toolbar-tools" ng-syle="theme.button_selection_chat" >'+
                                  '<div>Escribe tu dirección de residencia</div>'+
                              '</div>'+
                          '</md-toolbar>'+
                          '<md-dialog-content style="padding:2%;">'+
                              '<form ng-cloak id="formAddress" name="formAddress">'+
                                  '<div class="form-group move-down">'+
                                      '<input type="text" id="Autocomplete2" ng-model="autocomplete" class="form-control" ng-autocomplete options="options" details="details" initial-address="initialAddress" />'+
                                  '</div>'+
                              '</form>'+
                          '</md-dialog-content>'+
                          '<md-dialog-actions style="background-color: #F1F1F1; color: white;">'+
                              '<div flex layout="row">'+
                                  '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
                                      '<md-button class="md-accent" ng-disabled="!autocomplete" ng-class="{\'disabled-conditions-button\': !autocomplete, \'register-form-button\': !theme.button_send_background_color}" ng-style="theme.button_send" ng-click="submitAddress()">'+
                                          'Enviar'+
                                      '</md-button>'+
                                  '</div>'+
                                  '<md-divider></md-divider>'+
                                  '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
                                      '<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
                                          'Cancelar'+
                                      '</md-button>'+
                                  '</div>'+
                              '</div>'+
                          '</md-dialog-actions>'+
                      '</md-dialog>'+
                  '</div>'+
              '</div>'+
          '</div>'
          );

          $templateCache.put('signature.html',
          '<md-dialog id="signature" aria-label="Security" style="margin: 5%;">'+
              '<div ng-if="progressCircular" align="center" class="loading">'+
                  '<md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
              '</div>'+
              '<form name="formSignature" ng-cloak autocomplete="off">'+
                  '<md-toolbar>'+
                      '<div class="md-toolbar-tools" style="background-color: white; border-bottom: 2px solid #D6DEE4;" ng-style="theme.header">'+
                        '<h2 style="color: #4c4e4f;" ng-bind-html="renderHtml(signingKeyTitle)"></h2>'+
                      '</div>'+
                '  </md-toolbar>'+
                  '<md-dialog-content class="fullscreen">'+
                      '<div class="md-dialog-content" style="padding-bottom: 1%; background-color: #1B6D9D;" ng-style="theme.backgroundColor">'+
                          '<md-card ng-if="signingKeySubTitle !== null" style="padding: 2%; box-shadow: none; text-align: center">'+
                          ' <p ng-bind-html="renderHtml(signingKeySubTitle)"></p>'+
                          '</md-card>'+
                          '<md-card  style="padding: 2%;">'+
                              '<p style="text-align: justify" ng-bind-html="renderHtml(signingExplanation)"></p>'+
                              '<div class="form-row">'+
                                  '<div class="form-group col-md-12" style="padding-top:2%;">'+
                                      '<div class="input-group" style="padding-bottom:2%;">'+
                                      '   <div class="input-group"><label ng-bind-html="renderHtml(signingLabel)"></label></div>'+
                                      '</div>'+
                                      '<div class="input-group">'+
                                          '<input class="form-control" type="{{inputType}}" ng-model="signature.key" placeholder={{signingKeyLabel}} autocomplete="off" required>'+
                                          '<div class="input-group-addon" style="background-color: #E9ECEF!important; border-color: #E9ECEF!important;">'+
                                              '<a href="" ng-click="show_hide_password()">'+
                                                '<i ng-show="!visibility" class="fa fa-eye-slash" aria-hidden="true"></i>'+
                                                '<i ng-show="visibility" class="fa fa-eye" aria-hidden="true"></i>'+
                                              '</a>'+
                                          '</div>'+
                                      '</div>'+
                                '  </div>'+
                              '</div>'+
                            '  <div class="form-row col-md-12">'+
                                  '<div class="form-group" style="padding-top:2%;">'+
                                      '<div class="input-group">'+
                                        '  <input class="form-control" type="{{inputTypeConfirm}}" ng-model="confirm" name="{{signingKeyLabelConfirm}} ng-disabled="!signature.key" placeholder="Confirmar contraseña" autocomplete="off" required>'+
                                          '<div class="input-group-addon" style="background-color: #E9ECEF!important; border-color: #E9ECEF!important;">'+
                                            '<a href="" ng-click="show_hide_password_confirm()">'+
                                              '<i ng-show="!visibilityConfirm" class="fa fa-eye-slash" aria-hidden="true"></i>'+
                                              '<i ng-show="visibilityConfirm" class="fa fa-eye" aria-hidden="true"></i>'+
                                            '</a>'+
                                          '</div>'+
                                      '</div>'+
                              '    </div>'+
                                  '<span ng-show="confirm && signature.key !== confirm" style="color: red;">'+
                                  ' <md-icon md-svg-src="images/icons/error_outline-24px.svg" style="color: #EE4140">'+
                                   '</md-icon>'+
                                     'Las contraseñas no son iguales'+
                                   '</span>'+
                              '</div>'+
                          '</md-card>'+
                      '</div>'+
                  '</md-dialog-content>'+
                  '<md-dialog-actions layout="row" ng-style="theme.footer">'+
                      '<div flex layout="row">'+
                          '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
                              '<md-button ng-click="createSignature()" ng-disabled="!signature.key || signature.key != confirm" class="md-accent" ng-class="{\'disabled-conditions-button\': !signature.key || signature.key !== confirm, \'register-form-button\': !theme.button_send_background_color}" ng-style="theme.button_send" ng-disabled="!formSignature.$valid">'+
                                'Enviar'+
                              '</md-button>'+
                        '  </div>'+
                        '  <md-divider></md-divider>'+
                          '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
                              '<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
                                  'Cancelar'+
                            '  </md-button>'+
                        '  </div>'+
                      '</div>'+
                  '</md-dialog-actions>'+
              '</form>'+
          '</md-dialog>'+
          '<script></script>'
          );

          $templateCache.put('signContract.html',
          '<md-dialog aria-label="Security" style="margin: 5%;">'+
              '<div ng-if="progressCircular" align="center" class="loading">'+
                  '<md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
              '</div>'+
              '<form name="formSignature" autocomplete="off" ng-cloak>'+
                  '<md-toolbar>'+
                      '<div class="md-toolbar-tools" style="background-color: white; border-bottom: 2px solid #D6DEE4;" ng-style="theme.header">'+
                        '  <h2 style="color: #4c4e4f;" ng-bind-html="renderHtml(signingKeyTitle)"></h2>'+
                      '</div>'+
                  '</md-toolbar>'+
                  '<md-dialog-content class="fullscreen">'+
                      '<div class="md-dialog-content" style="padding-bottom: 1%; background-color: #1B6D9D;" ng-style="theme.backgroundColor">'+
                          '<md-card ng-if="signingKeySubTitle !== null" style="padding: 2%; box-shadow: none; text-align: center">'+
                          ' <p ng-bind-html="renderHtml(signingKeySubTitle)"></p>'+
                          '</md-card>'+
                          '<md-card style="padding: 2%; box-shadow: none;">'+
                          '<p style="text-align: justify"" ng-bind-html="renderHtml(signingExplanation)"></p>'+
                          '<div style="text-align: center; font-size: 16px"><label><span ng-bind-html="renderHtml(contractDownloadLabel)"></span></label>' +
                              '<div ng-repeat="item in files">' +
                                  '<div style="text-align: center; font-size: 16px"><label><span>{{item.name}} </span><a download="{{item.name}}" ng-href="{{getContractUrl(item)}}"   ng-click="downloadContract(item)" target="_blank">AQUI</a></label></div>'+
                              '</div>' +
                           '</div>' +
                              '<div class="form-row">'+
                                  '<div ng-show="showMessage"  style="text-align: center; font-size: 16px">Para continuar es necesario que hagas clic sobre el link del contrato y/o la descarga del documento.</div>' +
                              '</div>'+
                              '<div class="form-row">'+
                                  '<div class="form-group col-md-12" style="padding-top:2%;">'+
                                      '<div class="input-group"><p ng-bind-html="renderHtml(signingLabelSign)"></p></div>'+
                                      '<div class="input-group"  ng-show="!isVoice">'+
                                          '<input class="form-control" type="{{inputType}}" ng-model="signature.key" placeholder={{signingKeyLabel}} autocomplete="off" required>'+
                                          '<div class="input-group-addon" style="background-color: #E9ECEF!important; border-color: #E9ECEF!important;">'+
                                          '<a href="" ng-click="show_hide_password()">'+
                                            '<i ng-show="!visibility" class="fa fa-eye-slash" aria-hidden="true"></i>'+
                                            '<i ng-show="visibility" class="fa fa-eye" aria-hidden="true"></i>'+
                                          '</a>'+
                                          '</div>'+
                                      '</div>'+
                                  '</div>'+

                              '</div>'+
                              '<div layout="column"       layout-align="start center" ng-if="isVoice">'+
                                '<div >'+
                                  
                                      '<md-button   aria-label="Grabar" target="_blank" ng-click="startRecord()"  >'+
                                          '<img class="circulo-img" ng-src="../images/icons/{{iconRecord}}.png"/>'+
                                      '</md-button>'+
                                  
                                '</div>'+
                                '<div >'+
                                    
                                          '<p style="text-align: center; color: #19517f; size: 12px" >{{clock}}</p>'+
                                    
                                '</div>'+
                                '<div  ng-if="existAudio">'+
                                  
                                      '<audio controls id="audio" src="" autoplay></audio>'+
                                  
                                '</div>'+
                            '</div>'+
                            '<div ng-if="passwordError" class="form-group col-md-12" style="padding-top:1%; color: red; font-size: 14px;">'+
                            '<div class="input-group" id="show_hide_password">'+
                                '<span>{{errorApplySignature}}</span>'+
                            '</div>'+
                        '</div>'+
                          '</md-card>'+
                      '</div>'+
                  '</md-dialog-content>'+
                  '<md-dialog-actions layout="row" ng-style="theme.footer">'+
                      '<div flex layout="row">'+
                          '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
                              '<md-button ng-click="submitSignaturePublic()" ng-disabled="((!formSignature.$valid && !isVoice) || (isVoice && !existAudio)) || disabled"  ng-class="{\'disabled-conditions-button\': ((!formSignature.$valid && !isVoice) || (isVoice && !existAudio)) || disabled, \'register-form-button\': !theme.button_send_background_color && !(((!formSignature.$valid && !isVoice) || (isVoice && !existAudio)) || disabled) }" ng-style="theme.button_send">'+
                                  'Enviar'+
                              '</md-button>'+
                          '</div>'+
                          '<md-divider></md-divider>'+
                          '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
                              '<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
                                  'Cancelar'+
                              '</md-button>'+
                          '</div>'+
                      '</div>'+
                  '</md-dialog-actions>'+
              '</form>'+
          '</md-dialog>'
          );

          $templateCache.put('security_questions.html',
          '<md-dialog aria-label="Security">'+
              '<div ng-if="progressCircular" align="center" class="loading">'+
                  '<md-progress-circular md-mode="indeterminate" class="md-warn md-hue-3" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
              '</div>'+
              '<form name="formQuentions" ng-cloak>'+
                  '<md-toolbar>'+
                    '  <div class="md-toolbar-tools" style="background-color: white; border-bottom: 2px solid #D6DEE4;">'+
                          '<h2 style="color: #4c4e4f;">Configura tus preguntas de seguridad</h2>'+
                      '</div>'+
                '  </md-toolbar>'+
                '  <md-dialog-content>'+
                      '<div class="md-dialog-content" style="background-color: #1B6D9D; padding-bottom: 1%;" ng-style="questionTheme.backgroundColor" ng-repeat="item in quentions.data track by $index">'+
                          '<md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch>'+
                              '<md-card-content>'+
                                  '<div class="form-group">'+
                                      '<label>{{item.question}}</label>'+
                                      '<div ng-if="item.answerOptions.length === 0">'+
                                          '<input type="text" class="form-control" ng-model="item.answer" id="answer{{$index}}" name="answer" placeholder="Ingrese su respuesta" required>'+
                                      '</div>'+
                                '  </div>'+
                            '  </md-card-content>'+
                        '  </md-card>'+
                      '</div>'+
                      '<div ng-if="!quentions">'+
                          '<md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch>'+
                              '<md-card-content>'+
                              '</md-card-content>'+
                        '  </md-card>'+
                      '</div>'+
                  '</md-dialog-content>'+
                  '<md-dialog-actions layout="row"  layout-align="center center">'+
                      '<md-button ng-click="submitAnswers()" ng-disabled="!formQuentions.$valid" ng-class="{\'disabled-temp-button\': !formQuentions.$valid, \'register-form-button\': !formQuentions.$invalid && !theme.button_send_background_color}" ng-style="questionTheme.button_send">'+
                          'Enviar'+
                      '</md-button>'+
                  '</md-dialog-actions>'+
              '</form>'+
          '</md-dialog>'
          );
          $templateCache.put('formViews.html',
  '<md-dialog id="formview" aria-label="Security" style="margin: 5%;">'+
          '<div ng-if="progress" align="center" class="loading">'+
        '<md-progress-circular md-mode="indeterminate" class="loader" md-diameter="60" style="margin-top: 20%;"></md-progress-circular>'+
        '</div>'+
        '<div style="overflow: hidden;" class="form-window">'+
        '<md-card id="container2" style="margin:0; height: 100%;">'+
        '  '+
  '<md-card-content class="main1" style="background-color: #F5F5F5;">'+
    '<md-content>'+
      '<form name="notificationForm">'+
        '<div style="margin-top: 20px" ng-init="read=false"></div>'+
        '<div ng-repeat="bodyItem in formBody track by $index" ng-if="bodyItem.metadata.visibility!==\'GONE\'" style="margin:2%;">'+
          '<html-info ng-if="bodyItem.metadata.defaultValue===\'INFO\' && bodyItem.targetField === \'INFO\'"></html-info>'+          
          '<string-input-form ng-if="bodyItem.metadata.constraints.type===\'String\' && bodyItem.targetField !== \'INFO\'"></string-input-form>'+
          '<number-input-form ng-if="bodyItem.metadata.constraints.type===\'Double\' && bodyItem.targetField !== \'INFO\'"></number-input-form>'+
          '<date-input-form ng-if="bodyItem.metadata.constraints.type===\'Date\' && bodyItem.targetField !== \'INFO\'"></date-input-form>'+
          '<select-input ng-if="bodyItem.metadata.constraints.type===\'Select\' && bodyItem.targetField !== \'INFO\'"></select-input>'+
          '<table-input ng-if="bodyItem.metadata.constraints.type===\'Table\'"></table-input>'+
          '<file-input ng-init="fileSetup($index)" ng-if="bodyItem.metadata.constraints.fileName!==undefined && bodyItem.targetField !== \'INFO\'"></file-input>'+
          '<regex ng-if="bodyItem.metadata.constraints.type===\'regex\' && bodyItem.targetField !== \'INFO\'"></regex>'+
          '<div style="margin-top: 20px; margin-bottom: 20px"></div>'+
        '</div>'+
      '</form>'+
    '</md-content>'+
  '</md-card-content>'+
  '<md-card-actions class="footer2" align="center" style="margin: 0; background-color: #EEEEEE; height: 12%; border-top: 1px solid lightgrey;">'+
   

    '<md-dialog-actions layout="row" ng-style="theme.footer">'+
    '<div flex layout="row">'+
        '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-up="onSwipeUp($event, $target)">'+
        '<md-button ng-if="type_cs !== \'information\'" ng-class="{\'md-raised md-primary\': notificationForm.$valid, \'create-temp-button-disabled\' : !notificationForm.$valid}" ng-click="sendMsg($event, formBody, id)" class="col-xs-12 col-sm-2 col-lg-1" ng-disabled="!notificationForm.$valid || chat == true">'+
        'Aceptar'+
      '</md-button>'+
      '  </div>'+
      '  <md-divider></md-divider>'+
        '<div flex layout="row" layout-align="center center" class="demo-swipe" md-swipe-down="onSwipeDown($event, $target)">'+
            '<md-button ng-click="closeDialog()" class="md-raised md-warn">'+
                'Cancelar'+
          '  </md-button>'+
      '  </div>'+
    '</div>'+
'</md-dialog-actions>'+


  '</md-card-actions>'+
'</md-card>'+

'</div>'+
'</md-dialog>'


          );


          return {};
        }
    }
  })
